import React, { SyntheticEvent, useEffect, useState, ChangeEvent } from 'react';

import { filter } from 'lodash';

import StepDescription from '../StepDescription/StepDescription';

import { TypeOfReport } from '../ReportSelector/ReportType.data';

import { SearchableDropdownValue } from '../Home.dataparser';

import './ProductSelector.scss';

export interface ProductSelectorProps {
  availableProducts: Array<SearchableDropdownValue>;
  reportType: TypeOfReport;
  allSelected: boolean;
  onProductChange: (value: SearchableDropdownValue[]) => void;
}

const ProductSelector = ({
  availableProducts,
  reportType,
  allSelected,
  onProductChange,
}: ProductSelectorProps) => {
  const [products, setProducts] = useState(availableProducts);

  useEffect(() => {
    availableProducts.map((prod) => (prod.isSelected = false));
    setProducts(availableProducts);
  }, [availableProducts, reportType]);

  useEffect(() => {
    onProductChange(products);
  }, [products, onProductChange]);

  const isSummaryReport = reportType === 'OSR' || reportType === 'UGR' || reportType === 'SRISR';

  const handleCheckbox = (event: SyntheticEvent) => {
    let isChecked = (event.currentTarget as HTMLInputElement).checked;
    let itemName = (event.currentTarget as HTMLInputElement).name;

    if (itemName === 'selecteAll') {
      let productList = products.map((item) => ({ ...item, isSelected: isChecked }));
      setProducts(productList);
    } else {
      let selectedProd = filter(availableProducts, (product) => product.value === itemName)[0];
      selectedProd.isSelected = isChecked;

      let productList = products.map((item) => {
        return item.value === selectedProd.value
          ? { ...item, isSelected: selectedProd.isSelected }
          : item;
      });
      setProducts(productList);
    }
  };

  const handleRadioButton = (e: ChangeEvent<HTMLInputElement>) => {
    let productList = products.map((item) => {
      return item.value === e.target.value ? { ...item, isSelected: true } : item;
    });
    setProducts(productList);
  };

  const productCheckboxes = products.map((product: SearchableDropdownValue) => {
    return (
      <div className="stats-product-selector__check-box-holder" key={product.value}>
        <label className="stats-product-selector__check-box-label">
          <input
            type="checkbox"
            name={product.value}
            className="stats-product-selector-list"
            checked={product.isSelected}
            onChange={handleCheckbox}
            key={product.value}
          />
          <span className="stats-product-selector__check-box-label">{product.label}</span>
        </label>
      </div>
    );
  });

  const productRadioList = products.map((product: SearchableDropdownValue) => {
    return (
      <div className="vol-form__check" key={product.value}>
        <label className="vol-form__check-label">
          <input
            name="products"
            type="radio"
            className="mr-2"
            value={product.value}
            checked={product.isSelected}
            onChange={handleRadioButton}
          />
          {product.label}
        </label>
      </div>
    );
  });

  return (
    <div className="stats-product-selector">
      <div className="stats-product-selector__section-title">
        <StepDescription
          order="2"
          description="Select the product(s) for which you wish to view stats data"
        />
      </div>

      <div className="stats-product-selector__section-element">
        {!isSummaryReport && productRadioList}

        {isSummaryReport && (
          <div>
            <div className="stats-product-selector__check-box-holder">
              <span className="stats-product-selector__check-box-label">
                <input
                  type="checkbox"
                  name="selecteAll"
                  checked={allSelected}
                  onChange={handleCheckbox}
                />
              </span>
              <span className="stats-product-selector__check-box-label">Select All</span>
            </div>
            <div className="stats-product-selector__check-box-holder">{productCheckboxes}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductSelector;
